module.exports = require("slick-carousel/slick/slick.css");